import { toast as sonnerToast } from 'sonner';

import type { ToastProps } from './Toast';
import { Toast } from './Toast';

export type ShowToastProps = Omit<ToastProps, 'id'>;

export function showToast(toastProps: ShowToastProps) {
  return sonnerToast.custom((id) => <Toast id={id} {...toastProps} />, {
    duration: toastProps.duration || 8000,
    position: toastProps.position ?? 'top-right',
  });
}
